import React from "react";

export default function Title({ className = "", children }) {
    return <div className={`title ${className}`}>{children}</div>;
}
